// extracted by mini-css-extract-plugin
export default {"errorBg":"Error_errorBg__EwJJW","error":"Error_error__9uczQ","title":"Error_title__WNFwj","subtitle":"Error_subtitle__L0dpw"};